<template>
<div>

    <!-- banner start -->
    <section
      class="banner_sec ealab_banner_sec">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="self_banner_hed">
              <!-- <h1 class="heading_1 mb_20 text_white font_bold">Ergo-Ally</h1> -->
              <h3 class="heading_3 mb_20 text_white font_bold">Ergo-Ally</h3>
              <p class="mb_36 text_white font_size_30 font_bold">
                Your powerful, global, and customizable self-assessment, training, and ergonomics program management tool.
              </p>
              <a href="learn-more" class="btn btn_primary">Learn More</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- banner end -->

    <!-- Heres start -->
    <section class="heres_sec bg_grey padding_100 position-relative">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 col-xl-2">
            <div class="meet_logo">
              <img src="../../assets/home/images/self_assessments/meet_logo.png" alt="img" />
            </div>
          </div>
          <div class="col-md-12 col-xl-12">
            <h3 class="heading_3 font_bold text_black mb_60 text-center">
              Meet Your Ergo-Allies!
            </h3>
          </div>
        </div>
        <div class="row justify-content-center mt-3">
          <div class="col">
            <div class="heres_box">
              <div class="ergo-ally-img-section">
                <img src="../../assets/home/images/self_assessments/Self.svg" alt="icon" />
              </div>
              <h6 class="heading_6">Self-Assessment <br />& Training</h6>
            </div>
          </div>

          <div class="col">
            <div class="heres_box">
              <div class="ergo-ally-img-section">
                <img src="../../assets/home/images/self_assessments/Backend.svg" alt="icon" />
              </div>
              <h6 class="heading_6">Dashboards <br />& Metrics</h6>
            </div>
          </div>

          <div class="col">
              <div class="heres_box">
                <div class="ergo-ally-img-section">
                  <img src="../../assets/home/images/self_assessments/Scheduling.svg" alt="icon" />
                </div>
                <h6 class="heading_6">Scheduling & <br />Admin Tools</h6>
              </div>
          </div>

          <div class="col">
            <div class="heres_box">
              <div class="ergo-ally-img-section">
                <img src="../../assets/home/images/self_assessments/Scalable.svg" alt="icon" />
              </div>
              <h6 class="heading_6">Scalable <br />Solutions</h6>
            </div>
          </div>

          <div class="col">
            <div class="heres_box">
              <div class="ergo-ally-img-section">
                <img src="../../assets/home/images/self_assessments/ealab_icon.png" alt="icon" />
              </div>
              <h6 class="heading_6">Lab Training <br />Modules</h6>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Heres end -->

    <!-- counter start -->
    <section
      id="counter-stats"
      class="wow fadeInRight py_70 bg_primary"
      data-wow-duration="1.4s"
    >
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-12 col-lg-12 col-xl-9">
            <div class="row">
              <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 stats">
                <div class="media">
                  <div class="media-body countries">
                    <div class="counting" data-count="21K">21</div>
                    <h5>Countries</h5>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 stats">
                <div class="media">
                  <div class="media-body users">
                    <div class="counting" data-count="100">100k+</div>
                    <h5>Users</h5>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 stats">
                <div class="media">
                  <div class="media-body">
                    <div class="counting" data-count="100">100+</div>
                    <h5>Engaging Videos</h5>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-3 col-lg-3 col-xl-3 stats">
                <div class="media">
                  <div class="media-body">
                    <div class="counting" data-count="20">20+</div>
                    <h5>Companies</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 col-lg-12 col-xl-3">
            <div class="request_btn">
            <router-link class="" :to="{ name: 'learn_more' }">
                <h2>Request</h2>
                <p>A Demo Today!</p>
            </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- counter end -->
         <!-- meet start -->
    <section class="meet_sec padding_100">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-xl-3">
            <div class="video-library mt_2">
              <a
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              class="text_black"
              >
              <div class="video_box">
                <img
                  src="../../assets/home/images/self_assessments/ealab_meetyourlab.png"
                  alt="img"
                  class="free_img"
                />
                <span>
                  <img
                    src="../../assets/home/images/free_resources/video.svg"
                    alt="img"
                    class="v_icon"
                  />
                  Meet Your Lab Ally
                </span>
              </div>
            </a>
            </div>
            <div class="video-library">
              <a
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal1"
              class="text_black"
              >
              <div class="video_box">
                <img
                  src="../../assets/home/images/self_assessments/ealab_helpyou.png"
                  alt="img"
                  class="free_img"
                />
                <span>
                  <img
                    src="../../assets/home/images/free_resources/video.svg"
                    alt="img"
                    class="v_icon"
                  />
                  Conducting Lab Evals
                </span>
              </div>
            </a>
            </div>
          </div>
          <div class="col-md-12 col-xl-9 left_content">
            <div class="meet_content">
              <h3 class="heading_3">How Can Ergo-Ally Help Your Lab Employees?</h3>
              <p>
                Managing ergonomics in lab environments is complex, especially across multiple sites. Ergo-Ally for Labs gives organizations clear visibility into ergonomic risk while providing practical, proactive tools to address issues before they escalate. Whether your teams work in research labs, clean rooms, or production environments, Ergo-Ally for Labs delivers meaningful, actionable steps and insights without adding administrative burden.
              </p>

              <h3 class="heading_3">
                How Can Ergo-Ally Lab Help You?
              </h3>
              <p>
                Ergo-Ally for Labs brings everything you need to confidently manage a lab ergonomics program into one integrated platform. Through lab-specific training, guided self-assessments, and easy-to-use tools for conducting lab ergonomic evaluations, you can identify risk, take action, and support safer work practices across your organization. Centralized dashboards and reporting provide visibility into trends, high-risk tasks, and follow-up needs, making it easier to manage programs across teams, sites, and roles. With Ergo-Ally for Labs, you have the tools to support both your people and your operational goals.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- meet end -->
    <div
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      class="modal fade meet_our_team_modal free_resources_form"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="hideModal"
            ></button>
          </div>
          <div class="modal-body">
            <div style="padding: 56.25% 0 0 0; position: relative">
              <iframe
                id="closed"
                src="https://player.vimeo.com/video/1118729474?h=50a9f357b3&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                title="Sitting Pretty"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      class="modal fade meet_our_team_modal free_resources_form"
      id="exampleModal1"
      tabindex="-1"
      aria-labelledby="exampleModalLabel1"
      aria-hidden="true"
      >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="hideModal1"
            ></button>
          </div>
          <div class="modal-body">
            <div style="padding: 56.25% 0 0 0; position: relative">
              <iframe
                id="closed1"
                src="https://player.vimeo.com/video/1118729198?h=7db9a5f3f5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                title="Sitting Pretty"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
// import { mapGetters } from "vuex";
import store from "@/store/index";

export default {
  name: "lab_ergonomics",
  created(){
     document.title = "PBErgo - "+this.$router.currentRoute.meta.page_title;
  },
  methods:{
    hideModal() {
      document.getElementById("closed").src += "";
    },
    hideModal1() {
      document.getElementById("closed1").src += "";
    },
  },
  mounted() {
   
    store.dispatch("Home/getHomeData").then(() => {});
  },
};
</script>